/**
 * Shared UI component for UI Page Header.
 * PARENT-CHILD CONTRACT: parent screens provide the data and configuration that
 * this wrapper renders or normalizes for reuse across the application.
 */
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

@Component({
  selector: 'ui-page-header',
  standalone: true,
  imports: [UiLabelTranslatePipe],
  templateUrl: './ui-page-header.component.html',
  styleUrl: './ui-page-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiPageHeaderComponent {
  readonly actionsAriaLabel = input('Page actions');
}
